import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { connect } from 'react-redux'
import {
  CustomCardColorBar,
  CustomMultiSelect,
  PageHeader,
  Periodo,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import { Panel } from 'primereact/panel'
import { withRouter } from 'react-router'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import useExpedicaoTps, { LOAD_MESSAGE } from './ExpedicaoTpsHook'
import ModalDataTable from '../../../../components/ModalDataTable/ModalDataTable'
import CustomPieChart from '../../../../components/CustomPieChart/CustomPieChart'
import * as colors from '../../../../assets/js/colors'

function ExpedicaoTps({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useExpedicaoTps()

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesGroupAssociatedToUser()
        break

      case LOAD_MESSAGE.GET_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getExpedicaoTpsInfo(
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          state.companiesGroupSelected,
          selectedTp,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>1.2 - Expedição TPs</PageHeader>
      <div style={{ marginTop: 16 }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-col-4">
                <CustomMultiSelect
                  showLabel={true}
                  label="Grupo de Empresas"
                  marginTop={10}
                  options={state.companiesGroups}
                  value={state.companiesGroupSelected}
                  onChange={localDispatch.onCompanieGroupChange}
                />
              </div>
              <div className="p-col-6 p-md-4">
                <Periodo
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onPesquisar={(pInicial, pFinal) =>
                    localDispatch.onSearchDashboardInfo(
                      state.companiesGroupSelected,
                      pInicial,
                      pFinal,
                    )
                  }
                />
              </div>
            </div>
            <div className="p-col-12 p-grid">
              <div className="p-col-12">
                <SectionTitle title={'Dados do T1'} />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomPieChart
                  title={'Motivos de Atraso T1'}
                  items={state.dashboardInfo.motivos_graph_data.t1}
                  cellColors={state.colors}
                  borderTopColor={colors.azul}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_t1_atrasados.toFixed(2)}
                  title={'Carros T1 Atrasados'}
                  subTitle={`em %`}
                  barColor={colors.error}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_entregas_paradas}
                  title={'Total de Entregas Paradas'}
                  subTitle={`em /un`}
                  barColor={colors.black}
                />
              </div>
            </div>
            <div className="p-col-12 p-grid">
              <div className="p-col-12">
                <SectionTitle title={'Dados do T2'} />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomPieChart
                  title={'Motivos de Atraso T2'}
                  items={state.dashboardInfo.motivos_graph_data.t2}
                  cellColors={state.colors}
                  borderTopColor={colors.azul}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_t2_atrasados.toFixed(2)}
                  title={'Carros T2 Atrasados'}
                  subTitle={`em %`}
                  barColor={colors.error}
                />
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.dashboardInfo.expedicoes}
                style={{
                  textAlign: state.dashboardInfo.expedicoes.length > 0 ? 'inherit' : 'center',
                }}
                emptyMessage="Não existem dados para serem exibidos"
                responsive
              >
                <Column field="tp_name" header="Operação" />
                <Column
                  field="qte_carros_t1"
                  header="Qte Carro T1"
                  style={{ textAlign: 'center', background: 'rgba(0,150,165,0.25)', width: 90 }}
                />
                <Column
                  style={{ textAlign: 'center', background: 'rgba(0,150,165,0.25)', width: 120 }}
                  header="Qte Carro T1 Atrasado"
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal('carros_t1_atrasados_items', data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.qte_carros_t1_late}
                    </TextBtn>
                  )}
                />
                <Column
                  header="Entregas Paradas"
                  style={{ textAlign: 'center', background: 'rgba(1,71,79,0.25)', width: 120 }}
                  body={data => (
                    <TextBtn
                      onClick={() => localDispatch.onClickOpenModal('entregas_paradas_items', data)}
                      color={colors.azul_escuro}
                    >
                      {data.entregas_paradas}
                    </TextBtn>
                  )}
                />
                <Column
                  field="carros_t2_roteirizados"
                  header="Carros Roter."
                  style={{ textAlign: 'center', background: 'rgba(0,104,118,0.35)', width: 100 }}
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal('carros_t2_roteirizados_items', data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.carros_t2_roteirizados}
                    </TextBtn>
                  )}
                />
                <Column
                  header="Carros Parados"
                  style={{ textAlign: 'center', background: 'rgba(0,104,118,0.35)', width: 100 }}
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal('carros_t2_parados_items', data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.carros_t2_parados}
                    </TextBtn>
                  )}
                />
                <Column
                  field="carros_t2_enviados"
                  header="Carros Enviados"
                  style={{ textAlign: 'center', background: 'rgba(0,104,118,0.35)', width: 100 }}
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal('carros_t2_enviados_items', data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.carros_t2_enviados}
                    </TextBtn>
                  )}
                />
                <Column
                  header="Carros Atrasados"
                  style={{ textAlign: 'center', background: 'rgba(0,104,118,0.35)', width: 100 }}
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal('carros_t2_atrasados_items', data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.carros_t2_atrasados}
                    </TextBtn>
                  )}
                />
                <Column
                  field="saida_ultimo_carro"
                  header="Saida Ultimo Carro"
                  style={{ textAlign: 'center', background: 'rgba(0,104,118,0.35)', width: 120 }}
                />
              </DataTable>
            </div>
          </div>
        </Panel>
      </div>
      <ModalDataTable
        fields={state.modalInfo.fields}
        data={state.modalInfo.data}
        onClose={localDispatch.onModalClose}
        title={state.modalInfo.title}
        show={state.modalInfo.show}
        width={state.modalInfo.width}
        fieldParser={state.modalInfo.fieldParser}
      />
    </>
  )
}

const mapToProps = ({
  dashboard: {
    statusOperacoes: { status, pInicial, pFinal },
  },
  system: { selectedTp },
}) => ({ status, pInicial, pFinal, selectedTp })
export default connect(mapToProps)(withRouter(ExpedicaoTps))
